let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ke1EK")).then(() => parcelRequire('6z0vX'));